module.exports = __webpack_public_path__ + "static/media/essentialism-book.1d562a11.jpg";